import { modTypes } from "@blings/blings-player";

export const isInteractiveMod = (type: modTypes): boolean => {
  switch (type) {
    case modTypes.interactiveOpen:
    case modTypes.interactiveLocation:
    case modTypes.interactiveCalendar:
    case modTypes.interactiveInput:
    case modTypes.interactiveGoto:
    case modTypes.interactiveConcat:
    case modTypes.interactiveJSExpression:
    case modTypes.onPlayerEvent:
    case modTypes.interactiveForm:
    case modTypes.embedElement:
      return true;
    default:
      return false;
  }
};
